export default {
  // Edge type descriptions
  expandEdge: "This is an expand edge",
  addressOwnership: "This is address ownership",
  sameIpAccount: "Same IP account",
  sameDeviceAccount: "Same device account",

  // Field labels
  sender: "Sender: ",
  receiver: "Receiver: ",
  currencyName: "Currency Name: ",
  totalQuantity: "Total Quantity: ",
  transactionHash: "Transaction Hash: ",
  transactionTime: "Transaction Time: ",
  transactionQuantity: "Transaction Quantity: ",
  total: "Total: ",
  averageQuantity: "Average Quantity: ",

  // Range connector
  to: " to ",
};
